import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import { TemplateOnScreenDisplay } from './TemplateOnScreenDisplay';

import 'swiper/css';
import 'swiper/css/pagination';

interface ChooseTemplateSwiperProps {
    templates: React.ReactNode[];
    onSlideChange?: (currentSlide: number) => void;
}

export const ChooseTemplateSwiper = ({ templates, onSlideChange }: ChooseTemplateSwiperProps) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const handleSlideChange = (swiper: SwiperType) => {
        const newSlide = swiper.activeIndex;
        setCurrentSlide(newSlide);
        onSlideChange?.(newSlide);
    };

    return (
        <div className="w-full">
            <Swiper
                slidesPerView={1.9}
                spaceBetween={10}
                centeredSlides={true}
                modules={[Pagination]}
                pagination={{ clickable: true }}
                onSlideChange={handleSlideChange}
            >
                {templates.map((template, index) => (
                    <SwiperSlide key={index}>
                        <div className="relative flex justify-center items-center py-8">
                            <div className={`relative`}>
                                <TemplateOnScreenDisplay className={`${currentSlide === index ? '!border-black' : ''}`}>{template}</TemplateOnScreenDisplay>
                                {currentSlide === index && (
                                    <div className="absolute top-2 left-2 w-6 h-6 bg-black rounded-full flex items-center justify-center">
                                        <svg
                                            className="w-4 h-4 text-white"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};